import { PieChartIcon } from 'lucide-react';

import { PageSubHeaderBreadcrumbs } from '@/components/organisms/PageSubHeader/PageSubHeader';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';
import { Skeleton } from '@/components/ui/skeleton';
import { useReport } from '@/modules/analytics/hooks/useReport';

type ReportBreadcrumbProps = { name?: string; isLoading?: boolean };

export const ReportBreadcrumb = ({ name, isLoading }: ReportBreadcrumbProps) => (
  <PageSubHeaderBreadcrumbs>
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbPage>
            <div className="flex h-8 w-8 items-center justify-center">
              <PieChartIcon size={16} className="text-foreground-muted" />
            </div>
            <div className="mr-4 ml-2 h-4 w-px bg-border" />
            {isLoading ? <Skeleton className="h-5 w-48" /> : name}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  </PageSubHeaderBreadcrumbs>
);

type Props = { reportId: string };

export const ReportDetailBreadcrumb = ({ reportId }: Props) => {
  const { report, status } = useReport(reportId);

  return <ReportBreadcrumb name={report?.name} isLoading={status === 'pending'} />;
};
